import { Intercom, IntercomModule } from "@supy-io/ngx-intercom";
import {
  Component,
  OnInit,
  ViewContainerRef,
  ViewChild,
  ElementRef,
  TemplateRef,
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";

import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";

import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";

import { environment } from "./../../../../../../environments/environment";
import { DomSanitizer } from "@angular/platform-browser";

import { threadId } from "worker_threads";
import { StripeService } from "./../../stripe.service";
import { FormUtil } from "src/app/utils/formutils";
import { GeneralUtil } from "src/app/utils/general";
import { ColorPickerModule } from "ngx-color-picker";
import { CommonModule } from "@angular/common";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { AccountantService } from "./../../accountant.service";
import { DashboardService } from "src/app/dashboard/dashboard.service";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { AddAccountantModalComponent } from "./../../modals/addAccountantModal.component";
import { AccountantsAssignmentsModalComponent } from "./../../modals/accountants-assignments-modal.component";
import { DashboardModule } from "src/app/dashboard/dashboard.module";
import { TagComponent } from "../../../common/tags/tag.component";
import { SharedDataService } from "src/app/dashboard/shared-data.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { HotToastService } from "@ngneat/hot-toast";

declare var jQuery: any;
declare var Tour: any;
declare var Stripe: any;
@Component({
  selector: "app-tags-library",
  templateUrl: "./tags-library.component.html",
  styleUrls: ["./tags-library.component.css"],
  imports: [
    DashboardModule,
    ColorPickerModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule,
    IntercomModule,
  ],
})
export class TagsLibraryComponent
  implements OnInit, AfterViewChecked, AfterViewInit
{
  @ViewChild("logoInput", { static: true }) logoInput: ElementRef;
  @ViewChild("logoImage", { static: true }) logoImage: ElementRef;

  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  company: any = {};
  practiceInfoForm: UntypedFormGroup;
  formUtil: FormUtil;
  delete_id: any = null;
  color: any;
  file: any;
  clients: any = null;
  fileForm: FormData = new FormData();
  card_brand: any = "";
  card_last4: any = "";
  display_name = "";
  generalUtil = new GeneralUtil();
  data: any = {};
  user: any = {};
  tour_finished: any;
  old_logo: any = null;
  coupon: any = "";
  invite_being_removed = null;
  couponModal = false;

  // QuickBooks integration mockup
  loading = false;
  quickBooksIntegrationStep = 1;
  selected: string;
  workspaces: string[];

  selectedAcc: string;
  accounts: any;
  accounts_names: string[];

  selectedAccountName: string;

  selectedCust: string;
  customers: string[];

  realmId = "";
  companyName = "";
  workspaceName = "";
  userFullname = "";

  assignments: any[];

  tag = { name: "", color: "" };
  editedTag = null;
  tags: any[] = [];

  tag_colors = [
    "#1ABC6E",
    "#34A9DB",
    "#3463DB",
    "#6B4AB2",
    "#CA309F",
    "#C37D9F",
    "#DAAF02",
    "#E67E22",
    "#E73C3C",
    "#724A4A",
    "#34495E",
    "#7B8D8E",
  ];

  constructor(
    private localStorage: LocalStorageService,
    private accountantService: AccountantService,
    private dashboardService: DashboardService,
    private formBuilder: UntypedFormBuilder,
    private toastr: HotToastService,
    private changeDetector: ChangeDetectorRef,
    vcr: ViewContainerRef,
    private modalService: BsModalService,
    public sanitizer: DomSanitizer,
    private intercom: Intercom,
    public dashboardStore: DashboardStore,
    private stripeService: StripeService,
    public sharedDataService: SharedDataService,
  ) {
    this.formUtil = new FormUtil();

    this.practiceInfoForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      logo: [null, []],
      website: [null, []],
      twitter: [null, []],
      facebook: [null, []],
      linkedin: [null, []],
      review_linkedin: [null, []],
      review_xero: [null, []],
      review_proadvisor: [null, []],
      review_yelp: [null, []],
      review_google: [null, []],
      color: [null, []],
      display_name: [null, []],
    });

    // this.changeDetector.detach(); // deactivate change detection
    // setInterval(() => {
    //   this.changeDetector.detectChanges(); // manually trigger change detection
    // }, 250);
  }

  ngOnInit(): void {
    this.dashboardStore.clientsLoaded.subscribe((clients) => {
      this.clients = this.dashboardStore.clients;
    });

    this.accountantService.getAccountingCompanyTags().then((res: any) => {
      this.tags = res;
    });

    this.accountantService.get_subscription_status().then((res: any) => {
      if (res.subscription !== null) {
        this.sharedDataService.data.tier = res.subscription.tier;
        this.sharedDataService.data.error_status =
          res.subscription.error_status;
        this.sharedDataService.data.stripe_subscription_status =
          res.subscription.stripe_subscription_status;
      }
      this.user = this.localStorage.get("user");
      this.changeDetector.detectChanges();
    });

    this.tour_finished = this.localStorage.get("tour_finished");

    this.dashboardService.show_loading.next(true);
    this.accountantService.get_company_info().then((info) => {
      console.log("company info loaded");
      this.company = info;
      console.log("company", this.company);

      this.practiceInfoForm.patchValue({
        name: this.company.name,
        website: this.company.url,
        twitter: this.company.twitter,
        facebook: this.company.facebook,
        linkedin: this.company.linkedin,
        review_linkedin: this.company.review_linkedin,
        review_yelp: this.company.review_yelp,
        review_google: this.company.review_google,
        review_xero: this.company.review_xero,
        review_proadvisor: this.company.review_proadvisor,
        color: this.company.color,
        display_name: this.company.display_name,
      });

      this.clients = this.dashboardStore.clients;

      this.color = this.company.color;
      this.practiceInfoForm.get("name").markAsTouched();
      this.dashboardService.show_loading.next(false);
    });
  }

  ngAfterViewChecked() {
    jQuery(document).trigger("refreshColorContrast");
  }

  ngAfterViewInit(): void {
    // Create a Stripe client.
    var stripe = Stripe(environment.stripeKey);
    // Create an instance of Elements.
    var elements = stripe.elements();
    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: "#32325d",
        lineHeight: "18px",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    };

    // Create an instance of the card Element.
    var card = elements.create("card", { style: style });

    if (document.getElementById("card-element") != null) {
      // Add an instance of the card Element into the `card-element` <div>.
      card.mount("#card-element");
      // Handle real-time validation errors from the card Element.
      card.addEventListener("change", function (event) {
        var displayError = document.getElementById("card-errors");
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = "";
        }
      });

      // Handle form submission.
      var form = document.getElementById("payment-form");
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        this.dashboardService.show_loading.next(true);
        stripe.createToken(card).then((result) => {
          if (result.error) {
            // Inform the user if there was an error.
            var errorElement = document.getElementById("card-errors");
            errorElement.textContent = result.error.message;
          } else {
            // Send the token to your server.
            this.accountantService.add_payment_method(result.token).then(
              (res: any) => {
                this.toastr.success("Success!", res.message);

                this.sharedDataService.data.stripe_subscription_status =
                  "active";
                this.dashboardService.show_loading.next(false);
                this.dashboardService.paymentDone.next(true);
              },
              (err) => {
                this.toastr.error("Error", err);
                this.dashboardService.show_loading.next(false);
              },
            );
            // stripeTokenHandler(result.token);
          }
        });
      });
    }
  }
  openAddAccountantModal(company) {
    this.bsModalRef = this.modalService.show(AddAccountantModalComponent);
    if (company != null) {
      this.bsModalRef.content.invited_to = company.id;
      this.bsModalRef.content.name = company.name;
      this.bsModalRef.content.pending_accountants = company.pending_accountants;
    }
  }

  public openAccountantAssignmentsModal(accountant) {
    console.log("Accountant: ", accountant);
    this.bsModalRef = this.modalService.show(
      AccountantsAssignmentsModalComponent,
      { class: "modal-lg", ignoreBackdropClick: true },
    );
    this.bsModalRef.content.ngOnChanges({
      clients: [],
      accountants: this.company.accountants,
      accountant: accountant,
    });
  }

  saveCompany(): void {
    this.dashboardService.show_loading.next(true);
    const fileList: FileList = this.logoInput.nativeElement.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.fileForm.append("file", file, file.name);
    }

    this.fileForm.append("name", this.practiceInfoForm.get("name").value);
    this.fileForm.append("url", this.practiceInfoForm.get("website").value);
    this.fileForm.append("twitter", this.practiceInfoForm.get("twitter").value);
    this.fileForm.append(
      "facebook",
      this.practiceInfoForm.get("facebook").value,
    );
    this.fileForm.append(
      "linkedin",
      this.practiceInfoForm.get("linkedin").value,
    );
    this.fileForm.append(
      "review_linkedin",
      this.practiceInfoForm.get("review_linkedin").value,
    );
    this.fileForm.append(
      "review_yelp",
      this.practiceInfoForm.get("review_yelp").value,
    );
    this.fileForm.append(
      "review_google",
      this.practiceInfoForm.get("review_google").value,
    );
    this.fileForm.append(
      "review_xero",
      this.practiceInfoForm.get("review_xero").value,
    );
    this.fileForm.append(
      "review_proadvisor",
      this.practiceInfoForm.get("review_proadvisor").value,
    );
    this.fileForm.append("color", this.practiceInfoForm.get("color").value);
    this.fileForm.append(
      "display_name",
      this.practiceInfoForm.get("display_name").value,
    );

    this.accountantService.update_company_info(this.fileForm).then(
      (res: any) => {
        this.toastr.success("Company info updated successfully!");
        const response = res;
        this.company.logo = response.logo;

        this.practiceInfoForm.patchValue({
          website: response.url,
          twitter: response.twitter,
          facebook: response.facebook,
          linkedin: response.linkedin,
          review_linkedin: response.review_linkedin,
          review_yelp: response.review_yelp,
          review_google: response.review_google,
          review_xero: response.review_xero,
          review_proadvisor: response.review_proadvisor,
          display_name: response.display_name,
        });

        this.localStorage.set("company", response);
        this.localStorage.set("client_preview", response);

        this.logoInput.nativeElement.value = "";
        this.dashboardService.show_loading.next(false);
      },
      (err) => {
        console.log(err);
        this.dashboardService.show_loading.next(false);
        this.toastr.error(err.error.message);
      },
    );
  }

  fileChange(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.logoImage.nativeElement.src = URL.createObjectURL(file);
      console.log(this.logoImage.nativeElement.src);
    }
  }

  changeColor(color): void {
    this.practiceInfoForm.patchValue({
      color: color,
    });

    this.company.color = color;
  }

  changeAccessLevel(accountant): void {
    this.accountantService
      .change_access_level(accountant.id, accountant.access_level)
      .then((res: any) => {
        let response = res;
        this.toastr.success("Access level changed successfully!");
      });
  }

  openModal(user_id, template: TemplateRef<any>): void {
    this.delete_id = user_id;
    this.modalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  confirm(): void {
    this.dashboardService.show_loading.next(true);
    this.accountantService.delete_staff(this.delete_id).then(
      (res: any) => {
        const response = res;

        for (let x = 0; x < this.company.accountants.length; x++) {
          if (this.delete_id == this.company.accountants[x].id) {
            this.company.accountants.splice(x, 1);
          }
        }

        this.delete_id = null;
        this.dashboardService.show_loading.next(false);
        this.modalRef.hide();
      },
      (err) => {},
    );
  }

  decline(): void {
    this.modalRef.hide();
    this.delete_id = null;
  }

  apply_coupon(): void {
    this.dashboardService.show_loading.next(true);
    this.accountantService.apply_coupon(this.coupon).then(
      (res: any) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.success(res.message);
        this.coupon = "";
        this.couponModal = false;
      },
      (err) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.error("Coupon could not be redeemed at this time.");
        this.coupon = "";
        this.couponModal = false;
      },
    );
  }

  confirmInviteRemoval(invite_id): void {
    this.dashboardService.show_loading.next(true);
    this.accountantService.remove_invite(invite_id).then(
      (res: any) => {
        const response = res;

        this.company.pending_accountants =
          this.company.pending_accountants.filter((i) => {
            return i.id != invite_id;
          });

        this.dashboardService.show_loading.next(false);
        this.invite_being_removed = null;
        this.toastr.success("Invite removed successfully.");
        this.modalRef.hide();
      },
      (err) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.error(err.error.message);
        this.modalRef.hide();
      },
    );
  }

  removeInvite(invite_id, template: TemplateRef<any>): void {
    this.invite_being_removed = invite_id;
    this.modalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  openDowngradeModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  openUpgradeModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  typeaheadOnSelect(event) {}

  goToCustomerPortal() {
    this.loading = true;
    this.stripeService
      .getCustomerPortalSession()
      .subscribe((res: any) => (window.location.href = res.url));
  }

  addTag() {
    this.accountantService.addTag(this.tag).then(
      (res: any) => {
        this.tags.push(res);
        this.toastr.success("Tag added successfully!");
        this.tag.name = "";
        this.tag.color = "";
      },
      (err) => {
        this.toastr.error(err.error.message);
      },
    );
  }

  saveTag(tag) {
    this.accountantService.editTag(tag).then((res: any) => {
      this.tags.forEach((t) => {
        if (t.uuid == res.uuid) {
          t.name = res.name;
          t.color = res.color;
        }
      });

      this.toastr.success("Tag saved successfully!");
      this.editedTag = null;
      this.tag = { name: "", color: "" };
    });
  }

  openRemoveTagModal(tag, template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm",
      initialState: { _tag: tag },
    });
  }

  openEditTagModal(tag, template: TemplateRef<any>): void {
    this.editedTag = Object.assign({}, tag);
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm",
      initialState: { _tag: tag },
    });
  }

  removeTag(tag) {
    this.accountantService.removeTag(tag.uuid).then((res: any) => {
      this.tags = this.tags.filter((t) => {
        return t.uuid != tag.uuid;
      });
      this.modalRef.hide();
      this.editedTag = null;
      this.tag = { name: "", color: "" };
      this.toastr.success("Tag removed successfully!");
    });
  }

  selectColor(color) {
    this.tag.color = color;
  }
}
